import React from 'react';

// services
import { GTMServices } from '@services/gtm';
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';

// component
import { Typo } from '@plataforma/components';

// styles
import * as S from './styles';

const Loyalty = () => {
  const goToLoyalty = () => {
    GTMServices.createDataLayer({ event: 'Fidelize - Banner - Saiba Mais' });
    window.location.href = getSessionItem('PLATAFORMA_FIDELIZE');
  };

  return (
    <S.Container data-testid="loyalty-banner">
      <S.Details>
        <Typo element="h2" size="xl-emphasys">
          Encontre oportunidades de novos negócios
        </Typo>
        <Typo element="p" size="base" margin={['xs', '0', 's']}>
          Um jeito simples e eficiente de gerar mais negócios e entregar valor
          para seu cliente.
        </Typo>
        <Typo
          data-testid="loyalty-banner-cta"
          element="a"
          size="xs-emphasys"
          color="brand-primary"
          onClick={() => goToLoyalty()}
          isLink
        >
          Clique para saber mais
        </Typo>
      </S.Details>
      <S.BannerImage>
        <img
          src="https://static.juntoseguros.com/images/logo-fidelize.svg"
          width="170"
          height="129"
          alt="person"
        />
      </S.BannerImage>
    </S.Container>
  );
};

export default Loyalty;
